import React from "react";
import PropTypes from "prop-types";
import CustomLegend from "./CustomLegend";

const HighchartsReact = window.HighchartsReact;

class AfricaMap extends React.Component {
  constructor(props) {
    super(props);

    this.selectCountry = this.selectCountry.bind(this);
  }
  componentDidMount() {
    this.selectCountry(this.props.selectedCountry);
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedCountry !== prevProps.selectedCountry) {
      this.selectCountry(this.props.selectedCountry);
    }
  }

  selectCountry(code) {
    const numberOfHighcharts = this.props.highcharts.charts.length;
    const { charts } = this.props.highcharts;
    const data = charts[numberOfHighcharts - 1].series[0].data;
    if (code !== "all") {
      return data.forEach(country => {
        if (country["hc-key"] === code) {
          country.update({ selected: true });
        } else if (country["hc-key"] !== code && country.selected === true) {
          country.update({ selected: false });
        }
        return country;
      });
    }
    return data.map(country => country.selected === true ? country.update({ selected: false }) : country);
  }

  render() {
    const { options, highcharts, selectedCountry, currentTab } = this.props;
    return (
      <div>
        <HighchartsReact
          highcharts={highcharts}
          constructorType={"mapChart"}
          options={options}
          key={selectedCountry}
        />
        <CustomLegend currentTab={currentTab} />
      </div>
    );
  }
}

export default AfricaMap;

AfricaMap.defaultProps = {
  currentTab: ""
};

AfricaMap.propTypes = {
  currentTab: PropTypes.string,
  options: PropTypes.shape({}).isRequired,
  highcharts: PropTypes.shape({
    charts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  selectedCountry: PropTypes.string.isRequired,
};
